<div class="modal-header">
  <h5 class="modal-title">Notifications</h5>
  <button type="button" class="btn-close" (click)="close()"></button>
</div>

<div class="modal-body">
  @if (inbox.groups$ | async; as groups) {
    @for (group of groups; track group.kind) {
      @if (group.candidates.length > 0) {
      <div class="notification-row" (click)="openRefresh(group)">
        <div class="notification-icon">
          <i [class]="group.icon"></i>
        </div>
        <div class="notification-content">
          <div class="notification-title">{{ group.title }}</div>
          <div class="notification-desc">{{ group.candidates.length }} {{ group.description }}</div>
        </div>
        <span class="notification-count">{{ group.candidates.length }}</span>
      </div>
      }
    }
    @if (groups.length === 2 && groups[0].candidates.length === 0 && groups[1].candidates.length === 0) {
      <div class="no-notifications">
        <i class="fas fa-check-circle"></i>
        <span>All up to date</span>
      </div>
    }
  }
</div>
